import React from "react";
import MenuItem from "@mui/material/MenuItem";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Menu from "./Menu";

const style = {
  "&:hover": {
    color: "#255CCE",
    backgroundColor: "#fff",
  },
};

export default function Profile() {
  return (
    <Menu
      buttonVariant="outlined"
      icons={[
        <MenuIcon htmlColor="#808080" fontSize="medium" />,
        <AccountCircleIcon sx={{ fontSize: "24px" }} htmlColor="#808080" />,
      ]}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      textStyle={{ color: "text.primary" }}
      buttonStyle={{
        padding: "5px 10px",
        borderRadius: "100px",
        borderColor: "#BFBFBF",
      }}
      paperStyle={{
        width: "208px",
        marginTop: "10px",
      }}
    >
      <MenuItem sx={style}>Sign up</MenuItem>
      <MenuItem sx={style}>Login</MenuItem>
    </Menu>
  );
}
